import styles from "./CircleLoader.module.css";

type Props = {
  size?: number;
  color?: string;
  strokeWidth?: number;
};

export default function CircleLoader({
  size = 24,
  color = "var(--color-green-3)",
  strokeWidth = 4,
}: Props) {
  return (
    <div style={{ width: size, height: size }}>
      <svg className={styles.spinner} viewBox="0 0 50 50">
        <circle
          className={styles.path}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
        />
      </svg>
    </div>
  );
}
